<template>
  <div class="apply-invoice-box">
    <div class="apply-tit">
      <h2>{{ $t('message["1040"]') }}</h2>
    </div>
    <div class="apply-form-box">
      <a-form
        ref="mainForm"
        :form="form"
        :disabled="submitting"
        :hide-required-mark="true"
        class="apply-invoice-form"
        :class="{'en-apply-invoice-form': getLang() === 'en'}"
        @submit.prevent="submitForm('mainForm')"
      >
        <a-form-item
          :label="`${invoiveNumberTit}：`"
          prop="amount"
        >
          <span>{{ invoiceMoney }}</span>{{ $t('message["1523"]') }}
        </a-form-item>
        <a-form-item
          :label="`${invoiveType}：`"
          prop=""
        >
          <a-form-item>
            <a-select
              v-decorator="[
                'titletype',
                {initialValue: titletype }
              ]"
              class="w-160"
              @change="titleTypeChange"
            >
              <a-select-option
                v-for="item in titTypeOptions"
                :key="item.value"
                :label="item.label"
                :disabled="type===1 && (item.value === 2)"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select
              v-decorator="[
                'type',
                { initialValue: type }
              ]"
              class="w-160 ml-16"
              @change="typeChange"
            >
              <a-select-option
                v-for="item in typeOptions"
                :key="item.value"
                :disabled="titletype===2 && (item.value === 1)"
                :label="item.label"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a
            href="javascript:;"
            class="ml-16"
            @click="invoiceDialog"
          >{{ $t('message["192"]') }}</a>
          <invoice-dialog
            ref="invoiceDia"
            :titletype="titletype"
            :type="type"
            @importData="importData"
          />
        </a-form-item>
        <a-form-item
          :label="`${invoiceConTitTxt}：`"
          prop="contenttype"
        >
          <a-input
            v-decorator="[
              'contenttype',
              {rules: decorators.contenttype, initialValue: itServiceTit }
            ]"
            :disabled="true"
            type="text"
            :placeholder="invoiceConPlace"
          />
        </a-form-item>
        <template v-if="titletype===2 && (type ===2)">
          <a-form-item
            :label="`${headTit}：`"
            prop="title"
          >
            <a-input
              v-decorator="[
                'title',
                {rules: decorators.title, initialValue: '' }
              ]"
              :placeholder="titlePlace"
            />
          </a-form-item>
        </template>
        <template v-if="titletype===1">
          <a-form-item
            :label="`${comName}：`"
          >
            <a-input
              v-decorator="[
                'title',
                {rules: decorators.title2, initialValue: '' }
              ]"
              :placeholder="comNamePlaceTit"
            />
          </a-form-item>
          <a-form-item
            :label="`${taxpayerNTip}：`"
            prop="identifynumber"
          >
            <a-input
              v-decorator="[
                'identifynumber',
                {rules: decorators.identifynumber, initialValue: '' }
              ]"
              :placeholder="identifynumberPlace"
            />
          </a-form-item>
        </template>
        <template v-if="titletype===1 && (type ===1)">
          <!-- <a-form-item
            label="单位名称："
            prop="title"
          >
            <a-input
              v-decorator="[
                'title',
                {rules: decorators.title2, initialValue: '' }
              ]"
              placeholder="请输入单位名称"
            />
          </a-form-item>
          <a-form-item
            label="纳税人识别号："
            prop="identifynumber"
          >
            <a-input
              v-decorator="[
                'identifynumber',
                {rules: decorators.identifynumber, initialValue: '' }
              ]"
              placeholder="请输入纳税人识别号"
            />
          </a-form-item> -->
          <a-form-item
            :label="`${regAdressTit}：`"
            prop="regaddress"
          >
            <a-input
              v-decorator="[
                'regaddress',
                {rules: decorators.regaddress, initialValue: '' }
              ]"
              :placeholder="addressPlaceholder"
            />
          </a-form-item>
          <a-form-item
            :label="`${regTelTit}：`"
            prop="regtel"
          >
            <a-input
              v-decorator="[
                'regtel',
                {rules: decorators.regtel, initialValue: '' }
              ]"
              :placeholder="reTelPlaceholder"
            />
          </a-form-item>
          <a-form-item
            :label="`${bankTit}：`"
            prop="bankdeposit"
          >
            <a-input
              v-decorator="[
                'bankdeposit',
                {rules: decorators.bankdeposit, initialValue: '' }
              ]"
              :placeholder="bankPlaceholder"
            />
          </a-form-item>
          <a-form-item
            :label="`${bankAccountTit}：`"
            prop="bankaccount"
          >
            <a-input
              v-decorator="[
                'bankaccount',
                {rules: decorators.bankaccount, initialValue: '' }
              ]"
              :placeholder="bankNumberPlace"
            />
          </a-form-item>
        </template>
        <a-form-item
          v-if="type === 2"
          :label="`${invoiceTypeTitTxt}：`"
          prop="invoiceType"
        >
          <a-radio-group
            v-decorator="['sort', {initialValue: sort}]"
            @change="getInType"
          >
            <a-radio value="1">
              {{ $t('message["237"]') }}
            </a-radio>
            <a-radio value="2">
              {{ $t('message["1605"]') }}
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <template>
          <a-form-item
            :label="`${receiveTit}：`"
            prop="consignee"
          >
            <a-input
              v-decorator="[
                'consignee',
                {rules: decorators.consignee, initialValue: '' }
              ]"
              :placeholder="receiveInvoicePlace"
            />
          </a-form-item>
          <template v-if="isPaper || type === 1">
            <a-form-item
              :label="`${contactTit}：`"
              prop="contact"
            >
              <a-input
                v-decorator="[
                  'contact',
                  {rules: decorators.contact, initialValue: '' }
                ]"
                :placeholder="contactInvoicePlace"
              />
            </a-form-item>
            <!-- <a-form-item
              label="收票地址："
            >
              <province-city
                placeholder="请选择"
                :data="provinceData"
              />
            </a-form-item> -->
            <province-city
              :placeholder="selectPlaceholder"
              :data="provinceData"
            />
          </template>
          <template v-else>
            <a-form-item
              :label="`${emailTit}：`"
            >
              <a-input
                v-decorator="[
                  'contact',
                  {rules: decorators.email, initialValue: '' }
                ]"
                :placeholder="emailPlaceholder"
              />
            </a-form-item>
          </template>
        </template>
        <a-form-item>
          <a-button
            class="login-btn"
            type="primary"
            html-type="submit"
          >
            {{ $t('message["1161"]') }}
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>
<script>
import InvoiceDialog from './accountList/invoice/InvoiceDialog'
// import ProvinceCity from './accountList/ProvinceCity'
import ProvinceCity from './accountList/Area'
import { mapActions, mapState } from 'vuex'
import { getLang } from '@/lib/storage'
export default {
  'name': 'ApplyInvoice',
  components: {
    InvoiceDialog,
    ProvinceCity
  },
  props: {
  },
  provide () {
    return {
      myForm: this.form
    }
  },
  data () {
    return {
      titletype: 1,
      type: 2,
      submitting: false,
      provinceData: {
        fieldvalue: {},
        fieldname: this.$t('message["1103"]'),
        fieldkey: 'add'
      },
      datas: [],
      form: this.$form.createForm(this),
      titTypeOptions: [
        {
          value: 1,
          label: this.$t('message["148"]')
        },
        {
          value: 2,
          label: this.$t('message["364"]')
        }
      ],
      typeOptions: [
        {
          value: 1,
          label: this.$t('message["1563"]')
        },
        {
          value: 2,
          label: this.$t('message["1562"]')
        }
      ],
      sort: '1',
      contenttype: this.$t('message["1363"]'),
      mainForm: {
        type: 2,
        titletype: 1,
        title: '',
        identifynumber: '',
        regaddress: '',
        regtel: '',
        bankdeposit: '',
        bankaccount: '',
        consignee: '',
        contact: '',
        pca: [],
        address: ''
      }
    }
  },
  computed: {
    ...mapState('account/invoice', ['invoiceMoney', 'decorators']),
    isPaper () {
      return this.type === 2 && this.sort * 1 === 2
    },
    comName () {
      return this.$t('message["149"]')
    },
    invoiveNumberTit () {
      return this.$t('message["269"]')
    },
    invoiveType () {
      return this.$t('message["270"]')
    },
    invoiceConTitTxt () {
      return this.$t('message["271"]')
    },
    invoiceTypeTitTxt () {
      return this.$t('message["273"]')
    },
    itServiceTit () {
      return this.$t('message["465"]')
    },
    bankTit () {
      return this.$t('message["552"]')
    },
    contactTit () {
      return this.$t('message["604"]')
    },
    taxpayerNTip () {
      return this.$t('message["657"]')
    },
    comNamePlaceTit () {
      return this.$t('message["759"]')
    },
    invoiceConPlace () {
      return this.$t('message["768"]')
    },
    titlePlace () {
      return this.$t('message["771"]')
    },
    bankPlaceholder () {
      return this.$t('message["781"]')
    },
    identifynumberPlace () {
      return this.$t('message["786"]')
    },
    contactInvoicePlace () {
      return this.$t('message["797"]')
    },
    receiveInvoicePlace () {
      return this.$t('message["798"]')
    },
    bankNumberPlace () {
      return this.$t('message["826"]')
    },
    emailPlaceholder () {
      return this.$t('message["828"]')
    },
    addressPlaceholder () {
      return this.$t('message["839"]')
    },
    reTelPlaceholder () {
      return this.$t('message["840"]')
    },
    selectPlaceholder () {
      return this.$t('message["855"]')
    },
    receiveTit () {
      return this.$t('message["1104"]')
    },
    headTit () {
      return this.$t('message["1160"]')
    },
    bankAccountTit () {
      return this.$t('message["1488"]')
    },
    emailTit () {
      return this.$t('message["1505"]')
    },
    regAdressTit () {
      return this.$t('message["1633"]')
    },
    regTelTit () {
      return this.$t('message["1634"]')
    }
  },
  async created () {
    // this.form = this.$form.createForm(this)
    const chain = await this.fetchInvoiceMoneyDatas()
    chain.fetch()
  },

  methods: {
    ...mapActions('account/invoice', ['fetchInvoiceHistoryDatas', 'ajaxApplyInvoice', 'fetchProviceCityDatas', 'fetchInvoiceMoneyDatas']),
    getLang,
    submitForm (formName) {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          values['content_type'] = 2
          values['sort'] = this.titletype === 1 && (this.type === 1) ? 2 : this.sort * 1
          if (values['sort'] !== 1) {
            values['address'] = this.provinceData.fieldvalue.address
            values['pca'] = Object.keys(this.provinceData.fieldvalue.code)
          }
          const obj = Object.assign(values, { amount: this.invoiceMoney })
          const chain = await this.ajaxApplyInvoice()
          chain.params(obj)
            .onSuccess(raw => {
              this.$router.replace({ path: '/account/invoice' })
            })
            .setForm(this.form)
            .fetch()
        }
      })
    },
    importData (item) {
      const { form, provinceData } = this
      const { fieldvalue } = provinceData
      setTimeout(() => {
        form.setFieldsValue({
          'title': item.title,
          consignee: item.consignee,
          // address: item.address,
          contact: item.contact,
          sort: item.sort + ''
          // pca: [item.province, item.city, item.area]
        })
      })
      this.sort = item.sort
      // provinceData.fieldvalue.code = item.code
      // provinceData.fieldvalue.address = item.address
      setTimeout(() => {
        this.$set(fieldvalue, 'address', item.address)
        this.$set(fieldvalue, 'code', item.address_merge)
      })
      if (item.title_type === 1) {
        form.setFieldsValue({
          identifynumber: item.detail.identifynumber
        })
        this.mainForm.identifynumber = item.detail.identifynumber
        if (item.type === 1) {
          form.setFieldsValue({
            regtel: item.detail.regtel,
            regaddress: item.detail.regaddress,
            bankdeposit: item.detail.bankdeposit,
            bankaccount: item.detail.bankaccount
          })
        }
      }
      this.$refs.invoiceDia.changeVisible(false)
    },
    async invoiceDialog () {
      let res = await this.fetchInvoiceHistoryDatas()
      res.params({
        titletype: this.titletype,
        type: this.type
      })
        .onSuccess(raw => {
          this.$refs.invoiceDia.changeVisible(true)
        })
        .fetch()
    },
    changeHandle (val) {
      this.mainForm.pca = val
    },
    titleTypeChange (val) {
      this.titletype = val
      if (this.titletype === 2) {
        this.type = 2
        this.form.setFieldsValue({
          type: 2
        })
      }
    },
    typeChange (val) {
      this.type = val
      if (this.type === 1) {
        this.titletype = 1
        this.form.setFieldsValue({
          titletype: 1
        })
      }
    },
    getInType (e) {
      this.sort = '' + e.target.value
    }
  }
}
</script>
<style lang="scss" scoped>
.apply-invoice-box::v-deep {
  padding: 40px  40px 0;
  .apply-tit {
    h2 {
      line-height: 56px;
      font-size: 32px;
      font-weight: bold;
    }
  }

  .apply-invoice-form {
    padding: 40px 56px 0;
  }
  .en-apply-invoice-form {
    .ant-row {
      padding-left: 220px;
      .ant-form-item-label {
        width: 210px;
        margin-left: -220px;
      }
    }
  }
   .ant-row {
        padding-left: 100px;
        .w-160 {
          width: 160px;
        }
        .ant-form-item-label {
          float: left;
          width: 90px;
          margin-left: -100px;
          label {
            color: #666;
          }
          text-align: right;
        }
        .ant-form-item-control-wrapper {
          float: left;
          width: 100%;
          .ant-row {
            padding-left: 0;
            float: left;
            margin-bottom: 0;
          }
        }
      }
}
</style>
